import { Injectable } from '@angular/core';

@Injectable()
export class jsoncomparator {
    public changes: any = [];
    JSONobjectchanges(oldVal: any, newVal: any) {
        this.changes = [];

        // find keys
        var keyObj1 = Object.keys(oldVal);
        var keyObj2 = Object.keys(newVal);
        
        // find values
        var valueObj1 = Object.values(oldVal);
        var valueObj2 = Object.values(newVal);
        for (var i = 0; i < keyObj1.length; i++) {
            if (keyObj2.filter(f => f == keyObj1[i]) != null && keyObj2.filter(f => f !== undefined && keyObj1[i] !== undefined && f.replace(/_/g,'').toLowerCase() == keyObj1[i].replace(/_/g,'').toLowerCase()).length > 0) {
                
                
                if (oldVal[keyObj1[i]] != newVal[keyObj1[i]]) {
                    this.changes.push([keyObj1[i]]);
                    
                }
            }
        }
        return this.changes;
    }
}



// WEBPACK FOOTER //
// ./src/shared/JSONcomparator.ts